import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType } from 'redux-observable';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import { default as CognitoUserAuthenticator, UserSessionDetails } from './CognitoUserAuthenticator';
import UserAuthenticationSucceed from '../events/UserAuthenticationSucceed';
import UserAuthenticationFailed from '../events/UserAuthenticationFailed';
import UserChangePasswordRequested from '../events/UserChangePasswordRequested';

export default (event$: Observable<Event>): Observable<Event> =>
    event$.pipe(
        ofType(UserChangePasswordRequested.type),
        mergeMap((event: UserChangePasswordRequested) => {
            return CognitoUserAuthenticator.changePassword(event.password).pipe(
                map((sessionDetails: UserSessionDetails) => {
                    return new UserAuthenticationSucceed(sessionDetails);
                }),
                catchError((message: string) => of(new UserAuthenticationFailed(message)))
            );
        })
    );



// WEBPACK FOOTER //
// ./src/application/user/epic/changePassword.ts